import type { ItemsRecord, PurchasedItemsResponse, StoresRecord } from "@/pocketbase-types"
import { defineStore, acceptHMRUpdate } from "pinia"

export type PurchasedItemProps = PurchasedItemsResponse<{
  item: Pick<ItemsRecord, "name">
  store: Pick<StoresRecord, "name">
}>

export const useHistoryStore = defineStore("history", {
  state: () => ({
    items: [] as PurchasedItemProps[]
  }),
  getters: {},
  actions: {
    async refresh() {
      this.items = await this.pb.collection("purchasedItems").getFullList({
        expand: "item,store",
        fields: "*,expand.item.name,expand.store.name",
        sort: "-dateAt"
      })
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useHistoryStore, import.meta.hot))
}
